/* eslint-disable react/prop-types */
// Dependecies
import React, { useState, useEffect } from 'react';
import { reject } from 'lodash';
import { useAccordionToggle } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Store
import user from '../../store/user';
import maintenaceCompany from '../../store/maintenaceCompany';
import maintenance from '../../store/maintenances';

// Hooks
import useLanguage from '../useLanguage';

// Image
import check from '../../../sass/images/icons/check.svg';

function useMantenaiceCompany() {
  const [reloadCompany, setReloadCompany] = useState(false);
  const [maintenancesCompany, setMaintenancesCompany] = useState([]);
  const [newMaintenancesCompany, setNewMaintenancesCompany] = useState(0);
  const [maintenancesBoolCompany, setMaintenancesBoolCompany] = useState(-1);
  const [loadingServicesCompany, setLoadingServicesCompany] = useState(false);
  const [filterCompany, setFilterCompany] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [openModalCancel, setOpenModalCancel] = useState(false);
  const [openModalStarsInvert, setOpenModalStarsInvert] = useState(false);
  const [openModalRequestReject, setOpenModalRequestReject] = useState(false);
  const [openModalImage, setopenModalImage] = useState(false);
  const [idService, setIdService] = useState(0);
  const [userStore] = user();
  const [, maintenancesActions] = maintenaceCompany();
  const [storeMantenaice] = maintenance();
  const { locale } = useLanguage();
  const [star, setStar] = useState(0);
  const [imagen, setImagen] = useState(check);
  const [valuePlate, setValuePlate] = useState(0);
  const [messageAlert, setMessageAlert] = useState(false);
  const [urlImageService, setUrlImageService] = useState('');
  const [successfully, setSuccessfully] = useState(false);
  const history = useHistory();

  const [t] = useTranslation('routers', { useSuspense: false });

  useEffect(() => {
    if (userStore.token) {
      const data2 = {
        licensePlate: valuePlate,
      };

      maintenancesActions.setMaintenancesCompany(userStore.token, data2, locale).then(
        (maintenancesResponse) => {
          setMaintenancesCompany(maintenancesResponse.service);
          setMaintenancesBoolCompany(maintenancesResponse.bool);
          setNewMaintenancesCompany(maintenancesResponse.read);
          setReloadCompany(true);
          setLoadingServicesCompany(false);
          setFilterCompany(false);
          setMessageAlert(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
          reject('Error');
        }
      );
    }
  }, [userStore.token, loadingServicesCompany, filterCompany]);

  useEffect(() => {
    const time = setTimeout(() => {
      setMessageAlert(false);
    }, 10000);

    return () => {
      clearTimeout(time);
    };
  }, [messageAlert]);

  const closeModal = () => {
    setOpenModal(false);
    setOpenModalStarsInvert(false);
    setOpenModalRequestReject(false);
    setOpenModalCancel(false);
    setopenModalImage(false);
  };

  function update(
    id,
    optionSelect,
    whyRejectIt,
    status,
    questionnaire,
    stars,
    read,
    companyObservations,
    companyStars
  ) {
    const data = {
      id,
      option: optionSelect,
      whyRejectIt,
      status,
      questionnaire,
      stars,
      read,
      companyObservations,
      companyStars,
    };
    if (userStore.token) {
      maintenancesActions.update(userStore.token, data).then(
        (response) => {
          if (response.status === 200) {
            reject(response);
            setOpenModalRequestReject(false);
            setFilterCompany(true);
            closeModal();
          }
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }

  function CustomToggle({ children, eventKey, handleClick }) {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      handleClick();
    });

    return (
      <div className="arrow-card" onClick={decoratedOnClick}>
        {children}
      </div>
    );
  }

  CustomToggle.propTypes = {
    children: PropTypes.node.isRequired,
    eventKey: PropTypes.number,
    handleClick: PropTypes.func.isRequired,
  };
  
  CustomToggle.defaultProps = {
    eventKey: null,
  }

  const acceptModal = () => {
    setOpenModal(false);
    update(idService, 'Accept', '', 2, '', '', true, '', '');
  };

  function confirmCancel(id) {
    setIdService(id);
    setOpenModalCancel(true);
  }

  function cancelService() {
    closeModal();
    update(idService, 'None', 'canceled by the company', 5, '', '', false);
  }

  const onSubmit = (data, id) => {
    update(id, 'Deny', data.formDeny, 5, '', '', true, '', '');
  };
  const onSubmitStartCompany = (data, id) => {
    update(id, 'Finalized', '', 4, '', '', true, data.description, data.stars);
    closeModal();
    setTimeout(() => {
      storeMantenaice.successfully = successfully;
      const url = `/${locale}/${t('QualifyService')}`;
      history.push(url);
    }, 800);
  };

  function aproveService(id) {
    setIdService(id);
    setOpenModalStarsInvert(true);
  }
  function searchLicensePlate(plate, img) {
    if (plate !== '') {
      setImagen(img);
    } else {
      setValuePlate(0);
      setImagen(img);
    }
    setFilterCompany(true);
  }

  function setUrlImageServices(img) {
    setUrlImageService(img);
    setopenModalImage(true);
  }

  function redirectJobRequest(route) {
    const url = `/${locale}/${route}`;
    history.push(url);
  }

  return {
    reloadCompany,
    maintenancesCompany,
    newMaintenancesCompany,
    maintenancesBoolCompany,
    openModal,
    openModalCancel,
    openModalStarsInvert,
    openModalRequestReject,
    openModalImage,
    closeModal,
    acceptModal,
    cancelService,
    idService,
    onSubmit,
    onSubmitStartCompany,
    star,
    setStar,
    CustomToggle,
    confirmCancel,
    searchLicensePlate,
    imagen,
    valuePlate,
    setValuePlate,
    messageAlert,
    aproveService,
    redirectJobRequest,
    setUrlImageServices,
    urlImageService,
    setSuccessfully,
  };
}

export default useMantenaiceCompany;
